export { getServerSideProps } from '@/views/diamonds';
export { default } from '@/views/diamonds';
